/** The "roll my daily state when the real day changes" pattern shared by bounties, duelPay and duelWinBoost. */
export interface DayStamp {
  day: number;
}

/** Stamps `day` on `s`; when it differs from the stamp, runs `reset` first. True when it rolled. */
export function dayRoll(s: DayStamp, day: number, reset: () => void): boolean {
  if (s.day === day) return false;
  s.day = day;
  reset();
  return true;
}
